import { useContext } from "react";
import { AuthContext } from "./AuthContext";

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }

  const { state, logout } = context;

  return {
    status: state.status,
    user: state.status === "authenticated" ? state.user : null,
    token: state.status === "authenticated" ? state.token : null,
    isAuthenticated: state.status === "authenticated",
    logout,
  } as const;
}
